import React, { Component } from 'react'
import SimpleTabs from './components/PendingApprovalTabPanel';

class PendingApprovalTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default PendingApprovalTab
  